import { ReactNode } from 'react'

/**
 * Base props shared between mobile and desktop versions
 * This prevents duplication of business logic
 */
export interface StatsCardBaseProps {
  icon: string | ReactNode
  iconAlt: string
  label: string
  helpText?: string
  value: string | ReactNode
  loading?: boolean
  className?: string
}

/**
 * Mobile layout variants based on design
 */
export type MobileLayoutVariant = 'justify-between' | 'gap'

/**
 * Base component with shared logic
 * Contains only business logic, no UI styling
 */
export const StatsCardBase = {
  /**
   * Formats the value for display
   */
  formatValue: (value: string | ReactNode, loading: boolean): string | ReactNode => {
    if (loading) return '—'
    return value
  },

  /**
   * Gets the display value
   */
  getDisplayValue: (value: string | ReactNode, loading: boolean): string | ReactNode => {
    return StatsCardBase.formatValue(value, loading)
  }
}
